import React from "react";
import PropTypes from "prop-types";
import { Schema } from "@sparefoot/react-commons";

const FacilityUnitMicroData = ({
	storageUnits = [],
	vehicleUnits = [],
	facilityName,
	facilityUrl,
	facilityImageUrl = "",
	baseUrl,
	facilityId
}) => {
	const createProductSchemas = () => {
		const schemas = [];
		const sanitizeSizeText = (sizeText) => sizeText.replace(/['\s]/g, "");

		storageUnits.forEach((unit) => {
			const sizeFragment = sanitizeSizeText(unit.sizeText);
			const unitId = encodeURIComponent(unit.id);
			schemas.push({
				"@context": "https://schema.org",
				"@type": "Product",
				"@id": `${baseUrl}${facilityUrl}#${unitId}#${sizeFragment}#product`,
				name: facilityName,
				description: `${unit.sizeText} Storage Unit - ${facilityName}`,
				productID: facilityId,
				url: `${baseUrl}${facilityUrl}#${unitId}#${sizeFragment}`,
				brand: {
					"@type": "Brand",
					name: facilityName
				},
				offers: {
					"@type": "Offer",
					price: unit.lowestPrice,
					priceCurrency: "USD",
					availability: "https://schema.org/InStock"
				},
				...(facilityImageUrl && { image: facilityImageUrl })
			});
		});

		vehicleUnits.forEach((unit) => {
			const sizeFragment = sanitizeSizeText(unit.sizeText);
			const unitId = encodeURIComponent(unit.id);
			schemas.push({
				"@context": "https://schema.org",
				"@type": "Product",
				"@id": `${baseUrl}${facilityUrl}#${unitId}#${sizeFragment}#product`,
				name: facilityName,
				description: `${unit.sizeText} Vehicle Storage - ${facilityName}`,
				productID: facilityId,
				url: `${baseUrl}${facilityUrl}#${unitId}#${sizeFragment}`,
				brand: {
					"@type": "Brand",
					name: facilityName
				},
				offers: {
					"@type": "Offer",
					price: unit.lowestPrice,
					priceCurrency: "USD",
					availability: "https://schema.org/InStock"
				},
				...(facilityImageUrl && { image: facilityImageUrl })
			});
		});

		return schemas;
	};

	const productSchemas = createProductSchemas();

	return (
		<>
			{productSchemas.map((schema) => (
				<Schema
					key={schema["@id"]}
					schema={schema}
				/>
			))}
		</>
	);
};

FacilityUnitMicroData.propTypes = {
	storageUnits: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			sizeText: PropTypes.string.isRequired,
			tierDescription: PropTypes.string,
			lowestPrice: PropTypes.number,
			url: PropTypes.string
		})
	),
	vehicleUnits: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			sizeText: PropTypes.string.isRequired,
			tierDescription: PropTypes.string,
			lowestPrice: PropTypes.number,
			url: PropTypes.string
		})
	),
	facilityName: PropTypes.string.isRequired,
	facilityUrl: PropTypes.string.isRequired,
	facilityId: PropTypes.string.isRequired,
	facilityImageUrl: PropTypes.string,
	baseUrl: PropTypes.string.isRequired
};

export default FacilityUnitMicroData;
